import { useGoogleLogin as useGoogleLogin2 } from "@react-oauth/google";
import useGetEventFromApp from "hooks/useGetEventFromApp";
import useIsInappWebview from "hooks/useIsInappWebview";
import { useEffect, useState } from "react";
import { sendMessage } from "utils/webview";
import useLogin from "./useLogin";

/**
 * Google 로그인.
 * - 앱: 네이티브 SDK 가 준 idToken 을 그대로 서버로.
 * - 웹: 팝업 인가 코드를 서버로 보내고 **서버가** client_secret 으로 교환한다.
 *   (예전엔 브라우저가 직접 교환해 시크릿이 번들에 들어 있었다.)
 */
export default function useGoogleLogin() {
  const isInappWebview = useIsInappWebview();
  const origin = window.location.origin;

  const [idToken, setIdToken] = useState<string>();
  const [code, setCode] = useState<string>();

  const handleGoogleLoginApp = () => {
    sendMessage(JSON.stringify({ event: "google_login" }));
  };

  const parsedMessageFromApp = useGetEventFromApp();

  useEffect(() => {
    if (parsedMessageFromApp?.event === "google_idToken") {
      const idToken = parsedMessageFromApp.params.value;
      setIdToken(idToken);
    }
  }, [parsedMessageFromApp]);

  const login = useLogin({
    url: `/user/login`,
    idToken,
    code,
    redirectUri: code ? origin : undefined,
    type: "google",
  });

  useEffect(() => {
    if (idToken || code) {
      login();
    }
  }, [idToken, code]);

  const handleGoogleLoginWeb = useGoogleLogin2({
    onSuccess: (codeResponse) => setCode(codeResponse.code),
    flow: "auth-code",
    ux_mode: "popup",
    redirect_uri: origin,
  });

  return isInappWebview ? handleGoogleLoginApp : handleGoogleLoginWeb;
}
